export const es = {
   common: {
      location: "Ubicación",
      select_location: "Seleccionar Ubicación",
      no_location_found: "No se encontró Ubicación",
      production_line: "Línea de Producción",
      select_production_line: "Seleccionar Línea de Producción",
      no_production_line_found: "No se encontró Línea de Producción",
      denomination: "Denominación",
      select_denomination: "Seleccionar Denominación",
      no_denomination_found: "No se encontró Denominación",
      organization: "Organización",
      select_organization: "Seleccionar Organización",
      no_organization_found: "No se encontró Organización",
      account: "Cuenta",
      select_account: "Seleccionar Cuenta",
      no_account_found: "No se encontró Cuenta",
      depositing_customer: "Cliente Depositante",
      select_depositing_customer: "Seleccionar Cliente Depositante",
      no_depositing_customer_found: "No se encontró Cliente Depositante",
      select_product: "Seleccionar producto",
      no_product_found: "No se encontraron productos",
      success: "Éxito",
      error: "Error",
      cancel: "Cancelar",
      yes: "Sí",
      no: "No",
      noOptionsMessage: "Sin opciones",
      save: "Guardar",
      edit: "Editar",
      confirm: "Confirmar",
      add: "Agregar",
      complete: "Completar",
      rows_per_page: "Filas por página",
      show_more: "Mostrar más",
      show_less: "Mostrar menos",
      no_data_available: "No hay datos disponibles",
      deleted: "eliminado",
      select_user: "Seleccionar usuario",
      no_user_found: "No se encontró usuario",
      saved: "Guardado",
   },
   production: {
      production: "Producción",
      reload: "Recargar",
      reloadButtonToolTip: "Obtener nuevos datos",
      wrap_bag: "Envoltura/Bolsa",
      in_process_wrap: "En proceso de Envoltura/Bolsa",
      completed_wrap: "Envoltura/Bolsa Completada",
      audit: "Auditoría",
      in_process_audit: "Auditoría en Proceso",
      completed_audit: "Auditoría Completada",
      edited_completed_audit: "Auditoría Completada Editada",
      cancelled_audit: "Auditoría Cancelada",
      verification: "Verificación",
      in_process_verification: "Verificación en Proceso",
      completed_verification: "Verificación Completada",
      numi: "NUMI",
      in_process_numi: "NUMI en Proceso",
      completed_numi: "NUMI Completado",
   },

   wrap_bag: {
      wrap_bag: "envoltura/bolsa",
      user: "Usuario",
      date: "Fecha",
      product: "Producto",
      box_bags_$value: "Cajas/Bolsas | Valor $",
      control_id: "ID de Control",
      product_types: "Tipos de Producto",
      starting_count: "Conteo Inicial",
      finished_box_bags: "Cajas/Bolsas terminadas n.º",
      $value: "Valor $",
      completed: "Completado",
      select_control_id: "Seleccionar ID de Control",
      select_product_type: "Seleccionar Tipo de Producto",
      no_product_type: "No se encontró Tipo de Producto",
      select_denomination_first: "Seleccionar denominación primero",
      save: "Guardar",
      edit: "Editar",
      split: "Dividir",
      send_to_Audit: "Enviar a auditoría",
      delete: "Eliminar",
      print_control_tag: "Imprimir Etiqueta de Control",
      finished_greater_than_starting: "Las Cajas/Bolsas Terminadas deben ser mayores que el Conteo Inicial",
      value_exceed_10_percent: "El valor no debe ser mayor al +10% del valor original",
      count_present_in_control_id: "Conteo presente en el ID de Control",
      units_present_in_control_id: "Unidades presentes en el ID de Control",
      unit_present_in_control_id: "Unidad presente en el ID de Control",
      user_count: "Conteo de Usuario",
      count: "Conteo",
      updated: "actualizado",
      complete_session: "Completar Sesión",
      release_order: "Liberar Orden",
      reset: "Restablecer",
      end_of_day: "Fin del Día",
      end_of_day_sucessfully: "Fin del Día completado con éxito",
      end_of_day_message: "¿Está seguro de que desea finalizar el día?",
      add_product: "Agregar Producto",
      total_box_bag_value: "Valor Total de Cajas/Bolsas",
      total_converted_unit: "Unidades Convertidas Totales",
      total_changeovers: "Total de Cambios de Formato",
      over_short_value: "Exceso / Falta de Valor $",
      wrap_control_id: "ID de Control de Envoltura",
      delete_row: "Eliminar Fila",
      delete_row_confirmation: "¿Está seguro de que desea eliminar la fila?",
      wrapping_session_completed: "Sesión de envoltura completada con éxito",
      total_changeovers_saved: "Total de Cambios de Formato guardados con éxito",
      total_good_mixed_saved: "Valor total de productos mixtos buenos guardado con éxito",
      total_us_coin_bent_weight_saved: "Peso total de monedas dobladas de EE. UU. guardado con éxito",
      saved_succesfully: "Guardado con éxito",
      control_id_completed_succesfully: "ID de Control completado con éxito",
      control_id_split_succesfully: "ID de Control dividido con éxito",
      row_deleted_succesfully: "Fila eliminada con éxito",
      process_with_exceed_value: "Proceder con valor superior al de origen",
      process_with_exceed_value_message: "¿Está seguro de que desea continuar con más del +10% del valor de origen?",
      control_id_wrapping: "Envoltura de ID de Control",
      force_end_of_day: "Forzar fin del día",
      force_end_of_day_message: "¿Estás seguro de que deseas forzar el fin del día?",
      force_end_of_day_sucessfully: "Fin del día forzado con éxito",
      mixed_scan_error: "No se permite el embalaje de ID de control de denominaciones mixtas",
      user_production_count_delete: "eliminar conteo",
      delete_user_count: "eliminar conteo del usuario",
      delete_user_count_message: "¿Estás seguro de que deseas eliminar el conteo de {{user}}?",
      max_wrap_value_exceed: "El monto de envoltura/bolsa excede el máximo ($200,000.00)",

      //in_Process_wrap / Completed
      total: "Total",
      employee: "Empleado",
      org_acc: "Org | Cuenta",
      stc_value: "Valor STC",
      actions: "Acciones",
      edit_in_process_wrap_bag: "Editar envoltura/bolsa en proceso",
      view_completed_wrap_bag: "Ver envoltura completada",
      wrapping: "Envolviendo",
      edit_wrap_bag: "Editar envoltura/bolsa",
      delete_edit_in_process_wrap_bag: "Eliminar envoltura/bolsa en proceso",
      delete_in_process_wrap_bag: "Eliminar envoltura/bolsa en proceso",
      delete_in_process_wrap_bag_message: "¿Estás seguro de que deseas eliminar la envoltura/bolsa en proceso?",
      delete_in_process_wrap_bag_successfully: "¡Envoltura/bolsa en proceso eliminada con éxito!",

      // reset: "Reset",
      control_id_found_succesfully: "ID de Control {{controlID}} encontrado con éxito",
      wrap_value_on_save_complete_message_warning: "El valor envuelto es menor de lo esperado. <0/>¿Está seguro de que desea <1>{{action}}</1> envolver?",
      wrap_value_on_save_complete_second_message: "¿Está seguro de que desea <0>{{action}}</0> la envoltura del ID de Control <0>{{controlID}}</0>?",
   },
   audit: {
      serach_control_id: "Buscar ID de control",
      control_id_required: "Se requiere ID de control",
      stc: "STC",
      control_ids: "ID(s) de control",
      required_reconcilliation: "Requiere conciliaciones",
      pallet_tare_weight: "Peso tara del pallet",
      pallet_weight: "Peso del pallet",
      production_emp_name: "Nombre del empleado de producción",
      notes: "Notas",
      collected_foreign_weight: "Peso extranjero recolectado",
      foreign_weight: "Peso extranjero",
      email: "Correo electrónico",
      print: "Imprimir",
      complete: "Completar",
      audit_confirmation_messsage: "¿Estás seguro de que deseas <0>{{action}}</0> la auditoría?",
      us_coin_bent_mute_weight: "Peso doblado/silenciado de moneda estadounidense",
      bent_weight: "Peso doblado",
      total_bent_weight: "Peso total doblado",
      good_mixed_product: "Producto bueno mezclado",
      product_required: "Se requiere producto",
      invalid_value: "Valor inválido",
      total_good_mixed: "Total de buenos mezclados",
      total_over_short: "Total sobrante/faltante",
      delete_good_mixed_warning_warning: "¿Estás seguro de que deseas eliminar el producto bueno mezclado?",
      delete_good_mixed_title: "Eliminar producto bueno mezclado",
      remove_product: "Eliminar producto",
      audit_delete_sucessfully: "¡Auditoría eliminada con éxito!",
      cancel_audit: "Cancelar auditoría",
      view_cancel_audit: "Ver auditoría cancelada",
      edit_in_process_audit: "Editar auditoría en proceso",
      edit_completed_audit: "Editar auditoría completada",
      delete_audit: "Eliminar auditoría",
      audit_delete_confirmation_message: "¿Estás seguro de que deseas eliminar la auditoría?",
      audit_save_complete_succesfully: "¡Auditoría {{action}} con éxito!",
      saved: "Guardado",
      completed: "Completado",
      edit_history: "Historial de ediciones",
      edit_time: "Hora de edición",
      performed_by: "Realizado por",
      field_change: "Cambio de campo",
      inital_value: "Valor inicial",
      changed_vlaue: "Valor cambiado",
      difference: "Diferencia",
      intial_weight: "Peso inicial",
      change_Weight: "Cambio de peso",
      weight_diffrence: "Diferencia de peso",
      audit_save_complete_edit_title: "Auditoría {{action}}",
   },
   verification: {
      verification_session: "Sesión de verificación",
      select_verification_session: "Seleccionar sesión de verificación",
      verification_session_save_comfirm_msg: "¡Sesión de verificación {{verificationSessionID}} {{confirmationMsg}} exitosamente!",
      date_required: "La fecha es obligatoria",
      billing_category: "Categoría de facturación",
      no_billing_category_found: "No se encontró categoría de facturación",
      select_billing_category: "Seleccionar categoría de facturación",
      required_billing_category: "Se requiere categoría de facturación",
      delete_row: "Eliminar fila",
      verification_delete_msg: "¿Estás seguro de que deseas eliminar la fila?",
      verification_acknowledge: "Todas las cantidades aprobadas y firmadas son definitivas y servirán como base para los totales de cualquier factura. Es responsabilidad del Cliente asegurarse de que estas cantidades sean correctas.",
      loc_agent_sign: "Firma del agente de ubicación",
      coinwrap_emp_sign: "Firma del empleado de Coinwrap",
      sign_isrequired: "Se requiere firma",
      session_id: "ID de sesión",
      processing_date: "Fecha de procesamiento",
      emp_name_required: "Se requiere el nombre del empleado",
      loc_required: "Se requiere la ubicación",
      org_required: "Se requiere la organización",
      acc_required: "Se requiere la cuenta",
      verifiction_saveconfirm_msg: "¿Estás seguro de que deseas <0>{{confirmAction}}</0> la verificación?",
      edit_verification: "Editar verificación",
      delete_verification: "Eliminar verificación",
      verifiction_delete_msg: "¿Estás seguro de que deseas <0>{{action}}</0> la verificación <1>{{deleteVerifictaionID}}</1>?",
      verificataion_delete_sucessfully: "Verificación eliminada con éxito",
   }
};

// isByPassVaultCount;
